import "./Footer.scss";
import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebook,
  FaEnvelope,
  FaPhone,
  FaGlobe,
  FaHeart,
  FaArrowRight,
} from "react-icons/fa";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: "Company",
      links: [
        { text: "About Us", path: "/about" },
        { text: "Contact", path: "/contact" },
        { text: "Privacy Policy", path: "/privacy-policy" },
        { text: "Terms & Conditions", path: "/terms" },
      ],
    },
  ];

  const socialLinks = [
    {
      icon: <FaGlobe />,
      label: "Website",
      url: "https://lancehawks.com",
    },
    {
      icon: <FaEnvelope />,
      label: "Email",
      url: "mailto:contact@lancehawks.com",
    },
    {
      icon: <FaPhone />,
      label: "Phone",
      url: "tel:+919915697333",
    },
  ];

  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Main Footer */}
        <div className="footer-main">
          {/* Company Info */}
          <div className="footer-company">
            <h3 className="footer-logo">Lancehawks ERP</h3>
            <div className="footer-description">
              Transforming educational institutions with smart, comprehensive
              ERP solutions.
            </div>

            {/* Social Links */}
            <div className="footer-social">
              {socialLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label={link.label}
                >
                  {link.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            {footerLinks.map((category, index) => (
              <div key={index} className="footer-links-column">
                <h4>{category.title}</h4>
                <ul>
                  {category.links.map((link, linkIndex) => (
                    <li key={linkIndex}>
                      <Link to={link.path}>{link.text}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Contact Information */}
        <div className="footer-contact">
          <div className="contact-info">
            <div className="contact-item">
              <FaPhone className="icon" />
              <a href="tel:+919915697333">+91 991 569 7333</a>
            </div>
            <div className="contact-item">
              <FaEnvelope className="icon" />
              <a href="mailto:contact@lancehawks.com">contact@lancehawks.com</a>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-copyright">
            © {currentYear} Lancehawks Technologies. All rights reserved.
          </div>
          <div className="footer-credit">
            Made with <FaHeart className="heart-icon" /> by{" "}
            <a
              href="https://lancehawks.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Lancehawks Technologies
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
